import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { useState, useEffect } from "react";
import useTabDragAndDrop from "../useTabDragAndDrop";
import DraggableTab from "./DraggableTab";
import { Tab } from "../Tab";
import { TabItem } from "../types";

export const DynamicTabs = ({
  dynamicTabs,
  onReorder,
  handleTabChange,
  currentIndex,
}: {
  dynamicTabs?: TabItem[];
  onReorder?: (newOrder: TabItem[]) => void;
  handleTabChange?: (tabId: number) => void;
  currentIndex: number;
}) => {
  const [orderedDynamicTabs, setOrderedDynamicTabs] = useState<TabItem[]>([]);

  useEffect(() => {
    if (dynamicTabs) {
      setOrderedDynamicTabs(dynamicTabs);
    }
  }, [dynamicTabs]);

  const { handleDragStart, handleDragEnd, draggingIndex } = useTabDragAndDrop(
    orderedDynamicTabs,
    (newOrder) => {
      setOrderedDynamicTabs(newOrder);
      if (onReorder) {
        onReorder(newOrder);
      }
    },
  );

  if (!orderedDynamicTabs.length) {
    return null;
  }

  return (
    <DragDropContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
      <Droppable
        droppableId="dynamic-tabs"
        direction="horizontal"
        type="TAB"
        renderClone={(provided, snapshot) => (
          <div
            className={`flex w-full items-center justify-start overflow-x-auto whitespace-nowrap ${
              snapshot.draggingOver ? "bg-gray-50" : ""
            }`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <Tab
              key={orderedDynamicTabs[draggingIndex].id}
              tab={orderedDynamicTabs[draggingIndex]}
              index={draggingIndex}
              currentIndex={currentIndex}
              handleTabChange={handleTabChange}
              isDragging={snapshot.isDragging}
            />
          </div>
        )}
      >
        {(provided, snapshot) => (
          <div
            className={`flex w-full items-center justify-start overflow-x-auto whitespace-nowrap ${
              snapshot.isDraggingOver ? "bg-gray-50" : ""
            }`}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {orderedDynamicTabs.map((tab, index) => (
              <DraggableTab
                key={tab.id}
                tab={tab}
                index={index}
                currentIndex={currentIndex}
                handleTabChange={handleTabChange}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
